<div class="cerrix-add-and-filter-bar">
  <cerrix-icon-button
    text="Add new"
    icon="add"
    iconPosition="left"
    (click)="addButtonClicked.emit()"></cerrix-icon-button>
  <cerrix-search-input 
    class="cerrix-add-and-filter-bar-input"
    (valueChange)="valueChange.emit($event)"
  ></cerrix-search-input>
</div>
 